export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q03_b.1d5f9baa.png";